var map = {
	"./close.svg": "./src/icons/svg/close.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./database.svg": "./src/icons/svg/database.svg",
	"./dianchi.svg": "./src/icons/svg/dianchi.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./file.svg": "./src/icons/svg/file.svg",
	"./filter.svg": "./src/icons/svg/filter.svg",
	"./folder.svg": "./src/icons/svg/folder.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./index.svg": "./src/icons/svg/index.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./logout.svg": "./src/icons/svg/logout.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./page-first.svg": "./src/icons/svg/page-first.svg",
	"./page-last.svg": "./src/icons/svg/page-last.svg",
	"./page-next.svg": "./src/icons/svg/page-next.svg",
	"./page-previous.svg": "./src/icons/svg/page-previous.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./report.svg": "./src/icons/svg/report.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./workstatus.svg": "./src/icons/svg/workstatus.svg",
	"./zoom-in.svg": "./src/icons/svg/zoom-in.svg",
	"./zoom-out.svg": "./src/icons/svg/zoom-out.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";